
import { cloudLSDPermissionsLogout } from '@/api/home'
export function buildDynamicCompareData(arrData) {
  // 先找到最大年份、最大月份
  let maxItem = arrData.reduce((a, b) => {
    if (a.year !== b.year) return a.year > b.year ? a : b;
    return a.month > b.month ? a : b;
  });

  // 生成 12 个月的配对
  const monthPairs = [];
  let y = maxItem.year, m = maxItem.month;

  for (let i = 0; i < 12; i++) {
    let current = { year: y, month: m };
    let last = { year: y - 1, month: m };

    monthPairs.push({ current, last });

    // 往前一个月
    m--;
    if (m === 0) {
      m = 12;
      y--;
    }
  }

  // 倒序（因为推出来是从大到小）
  monthPairs.reverse();

  const find = (year, month) =>
    arrData.find(d => d.year === year && d.month === month) || {};

  const result = {
    xAxisData: [],
    totalValue: { last: [], current: [] },
    importValue: { last: [], current: [] },
    exportValue: { last: [], current: [] },
    // 新增的字段
    dataItem: { last: [], current: [] },
    dataItem2: { last: [], current: [] } // ✅ 新增
  };

  const pickItem = (item) => ({
    totalValue: item?.totalValue || 0,
    importValue: item?.importValue || 0,
    exportValue: item?.exportValue || 0,
    yoyChange: item?.yoyChange || 0,
    importYoyChange: item?.importYoyChange || 0,
    exportYoyChange: item?.exportYoyChange || 0
  });


  monthPairs.forEach(({ current, last }) => {
    const cur = find(current.year, current.month);
    const lst = find(last.year, last.month);

    result.xAxisData.push(current.month + '月');

    result.totalValue.current.push(cur.totalValue || 0);
    result.totalValue.last.push(lst.totalValue || 0);

    result.importValue.current.push(cur.importValue || 0);
    result.importValue.last.push(lst.importValue || 0);

    result.exportValue.current.push(cur.exportValue || 0);
    result.exportValue.last.push(lst.exportValue || 0);
    // 新增整条数据存入
    result.dataItem.current.push(cur);
    result.dataItem.last.push(lst);

    // ✅ 增加精简对象 push
    result.dataItem2.current.push(pickItem(cur));
    result.dataItem2.last.push(pickItem(lst));
  });

  return result;
}

export function getLast12FullData(arrData) {
  // 找最大年、月
  const maxItem = arrData.reduce((a, b) => {
    if (a.year !== b.year) return a.year > b.year ? a : b;
    return a.month > b.month ? a : b;
  });

  let y = maxItem.year;
  let m = maxItem.month;

  const result = [];

  for (let i = 0; i < 12; i++) {
    // 查找该年月数据
    const item = arrData.find(d => d.year === y && d.month === m);

    if (item) {
      result.push(item);
    } else {
      // 没有数据就补零
      result.push({
        provinceName: "",
        cityName: "",
        totalValue: 0,
        importValue: 0,
        exportValue: 0,
        year: y,
        month: m
      });
    }

    // 往前一个月
    m--;
    if (m === 0) {
      m = 12;
      y--;
    }
  }

  return result.reverse(); // 调整顺序从旧到新
}


export async function clearAllCookies() {
  sessionStorage.clear();
  await cloudLSDPermissionsLogout({})

}


export function formatNumber(num) { //数字千分位符1,000.00
  return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 20 });
}